import React from 'react';
import { getCaretPosition, getSelectedText } from '../../../../../../Helpers/Chat/ContentEditableEle.js';
import { placeCaretAtEnd } from '../../../../../../Helpers/Utility';

const ContentEditable = (props = {}) => {
    let typingContainner =  React.useRef(null);
    const {
        id = "",
        html = "",
        placeholder = "",
        onKeyDownListner = () => { },
        onInputListener = () => { },
        handleMessage = () => { },
        handleSendTextMsg = () => { },
        handleEmptyContent = () => { },
        setSelectedText = () => { },
    } = props;
    const pasteAsPlainText = (event = {}) => {
        event.preventDefault()
        if (document && document.activeElement instanceof HTMLElement) {
            const text = event.clipboardData.getData('text/plain');
            const selection = window.getSelection();
            if (!selection.rangeCount) return;
            selection.deleteFromDocument();
            selection.getRangeAt(0).insertNode(document.createTextNode(text));
            placeCaretAtEnd(typingContainner.current);
            emitChange();
        }
    }
    const emitChange = (event) => {
        let htmlInput = typingContainner.current.innerHTML;
        if (handleMessage) {
            onInputListener()
            handleMessage({
                target: {
                    value: htmlInput
                }
            });
        }
        if (!htmlInput && htmlInput.replace(/^\s+/, "") === htmlInput) {
            return
        }
    }

    const handleOnKeyDownListner = (e = {}) => {
        onKeyDownListner && onKeyDownListner(e)
        if (e.which === 13 && e.shiftKey === false) {
            e.preventDefault()
            if (typingContainner.current.innerHTML.replace(/^\s+/, "") === "" ||
            typingContainner.current.innerHTML.includes("<div><br></div>")) {
            return false;
         }
            handleSendTextMsg()
            handleEmptyContent()
            return false;

        }
        return true;
    }
    
    React.useEffect(()=>{
        if(html.length === 0){
            typingContainner.current.innerHTML = ""
        }
    },[html])

    React.useEffect(()=>{
        if (props.html !== typingContainner.current.innerHTML) {
            typingContainner.current.innerHTML = props.html;
        }
    },[props.html,props])
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
    };
    return (
        <div
            id={id}
            name="typingMessage"
            contentEditable="true"
            className="typing-area"
            onInput={emitChange}
            onPaste={pasteAsPlainText}
            onKeyDown={(e)=> {handleOnKeyDownListner(e)}}
            data-jest-id={"jestContentEditable"}
            suppressContentEditableWarning={true}
            data-text={placeholder ? placeholder : "Start typing..."}
            ref={typingContainner}
            onFocus={(e) => {
                e.target.classList.add('incaption')
            }}
            onBlur={(e) => {
                e.target.classList.remove('incaption')
                setSelectedText && setSelectedText(getSelectedText());
            }}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
        </div>)
}

export default ContentEditable;
